import React, {PureComponent} from "react"
import styled from "styled-components"

import Icon from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"

import Flex from "@irati/ui/src/Flex"

interface Props {
  text: string
}

const Wrapper = styled(Flex)`
  ${Icon} {
    margin-right: 5px;
    fill: ${({theme}) => theme.colors.greys.black};
  }
`

export default class Online extends PureComponent<Props> {
  render() {
    return (
      <Wrapper alignItems="center" flex="0 0 auto">
        <Icon icon="online" />
        <Body small>{this.props.text}</Body>
      </Wrapper>
    )
  }
}
